import React from "react";
import "./index.css";
import Logo from "../../../../Assets/Logo/ARNIE LOGO White.png";
const QuickOnlineHeader = () => {
  return (
    <div className="d-flex justify-content-center">
      <div style={{ height: "118px", width: "265px" }}>
        <img
          src={Logo}
          alt="image2"
          style={{ backgroundColor: "#359742" }}
          className="h-100 w-100 object-fit-contain"
        />
      </div>
    </div>
  );
};

export default QuickOnlineHeader;
